import React from 'react';
import { Spin } from '../../components/Spin';
import loadable from '../../utils/loadable';

export default loadable(() => import('./index'), {
  fallback: <Spin />,
});
